// src/components/sops/SopCatalogLinks.js — sopweb-bdb7afcd (SOPs Library, Seam 2)
// "Show it on jobs automatically": catalog item chips + "+ Add catalog item". Searching asks the
// server a few results at a time (searchCatalogPicker via useQuickCatalogSearch, catpick-4d7b19e3) —
// the browser never loads the whole catalog. items = [{ id, name }].
import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { useQuickCatalogSearch } from '../documents/useCatalogSearch';
import { inputClass } from './SopUi';
import { LIMITS } from '../../utils/sopsUi';

export default function SopCatalogLinks({ items, onChange, disabled }) {
    const [adding, setAdding] = useState(false);
    const [text, setText] = useState('');
    const search = useQuickCatalogSearch(adding ? text : '', { max: 8 });
    const has = new Set(items.map((i) => i.id));
    const full = items.length >= LIMITS.CATALOG_IDS_MAX;

    const add = (item) => {
        if (has.has(item.id) || full) return;
        onChange([...items, { id: item.id, name: item.name }]);
        setText('');
    };

    return (
        <div>
            <div className="flex flex-wrap gap-2">
                {items.map((i) => (
                    <span key={i.id} className={`inline-flex items-center gap-1 rounded-full border px-3 py-1 text-sm ${i.missing ? 'border-amber-300 bg-amber-50 text-amber-900' : 'border-[#5F4EC9]/30 bg-[#5F4EC9]/5 text-[#12192D]'}`}>
                        {i.name}
                        {!disabled && <button type="button" aria-label={`Remove ${i.name}`} onClick={() => onChange(items.filter((x) => x.id !== i.id))} className="text-gray-500 hover:text-gray-800"><X size={14} /></button>}
                    </span>
                ))}
                {!adding && !disabled && !full && (
                    <button type="button" onClick={() => setAdding(true)} className="inline-flex items-center gap-1 rounded-full border border-dashed border-gray-300 px-3 py-1 text-sm text-[#5F4EC9] hover:bg-gray-50">
                        <Plus size={14} /> Add catalog item
                    </button>
                )}
            </div>
            {full && <p className="mt-1 text-xs text-gray-500">That’s the most: {LIMITS.CATALOG_IDS_MAX} catalog items.</p>}
            {adding && (
                <div className="mt-2 rounded-lg border p-2">
                    <div className="flex gap-2">
                        <input autoFocus aria-label="Search the catalog" className={inputClass} placeholder="Type at least 2 letters of an item name" value={text}
                            onChange={(e) => setText(e.target.value)} onKeyDown={(e) => { if (e.key === 'Escape') { setAdding(false); setText(''); } }} />
                        <button type="button" onClick={() => { setAdding(false); setText(''); }} className="text-sm text-gray-600 hover:underline px-2">Done</button>
                    </div>
                    <div className="mt-1 text-sm">
                        {search.status === 'loading' && <p className="px-2 py-1 text-gray-500">Searching…</p>}
                        {search.status === 'error' && <p className="px-2 py-1 text-red-700">{search.error}</p>}
                        {search.status === 'done' && search.items.length === 0 && <p className="px-2 py-1 text-gray-500">No catalog items match.</p>}
                        {search.items.map((it) => (
                            <button key={it.id} type="button" disabled={has.has(it.id)} onClick={() => add(it)}
                                className="block w-full rounded px-2 py-1.5 text-left hover:bg-gray-50 disabled:text-gray-400">
                                {it.name}{has.has(it.id) ? ' — added' : ''}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
